/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilestoreInfo
 */
export interface FilestoreInfo {
    /**
     * 
     * @type {string}
     * @memberof FilestoreInfo
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof FilestoreInfo
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof FilestoreInfo
     */
    bucketType: string;
    /**
     * 
     * @type {string}
     * @memberof FilestoreInfo
     */
    bucket: string;
    /**
     * 
     * @type {string}
     * @memberof FilestoreInfo
     */
    prefix: string;
    /**
     * 
     * @type {boolean}
     * @memberof FilestoreInfo
     */
    hasFiles: boolean;
    /**
     * 
     * @type {string}
     * @memberof FilestoreInfo
     */
    region: string;
}

/**
 * Check if a given object implements the FilestoreInfo interface.
 */
export function instanceOfFilestoreInfo(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "bucketType" in value;
    isInstance = isInstance && "bucket" in value;
    isInstance = isInstance && "prefix" in value;
    isInstance = isInstance && "hasFiles" in value;
    isInstance = isInstance && "region" in value;

    return isInstance;
}

export function FilestoreInfoFromJSON(json: any): FilestoreInfo {
    return FilestoreInfoFromJSONTyped(json, false);
}

export function FilestoreInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilestoreInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'id': json['id'],
        'bucketType': json['bucket_type'],
        'bucket': json['bucket'],
        'prefix': json['prefix'],
        'hasFiles': json['has_files'],
        'region': json['region'],
    };
}

export function FilestoreInfoToJSON(value?: FilestoreInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'id': value.id,
        'bucket_type': value.bucketType,
        'bucket': value.bucket,
        'prefix': value.prefix,
        'has_files': value.hasFiles,
        'region': value.region,
    };
}

